<div class="notification-list-container">
  @let grouped = groupedNotifications();

  @if (grouped.today.length > 0) {
    <div class="today-notification">
      <p class="notification-header">Today's Notifications</p>
      @for (notification of grouped.today; track notification.id) {
        <g99-lib-notification-card
          [notification]="notification"
          (notificationClick)="onNotificationClick($event)"
        />
      }
    </div>
  }

  @if (grouped.older.length > 0) {
    <div class="older-notification">
      <p class="notification-header">Older Notifications</p>
      @for (notification of grouped.older; track notification.id) {
        <g99-lib-notification-card
          [notification]="notification"
          (notificationClick)="onNotificationClick($event)"
        />
      }
    </div>
  }
</div>
